<div class="tagline bg-slate-900">
    <div class="container relative">
        <div class="grid grid-cols-1">
            <div class="flex items-center justify-between">
                <ul class="list-none">
                    <li class="inline-flex items-center">
                        <i data-feather="clock" class="text-red-500 size-4"></i>
                        <span class="ms-2 text-slate-300">Mon-Sat: 9am to 6pm</span>
                    </li>
                    <li class="inline-flex items-center ms-2">
                        <i data-feather="map-pin" class="text-red-500 size-4"></i>
                        <span class="ms-2 text-slate-300">Somewhere in Mönchengladbach</span>
                    </li>
                </ul>

                <ul class="list-none">
                    <li class="inline-flex items-center">
                        <i data-feather="mail" class="text-red-500 size-4"></i>
                        <a href="mailto:contact@example.com" class="ms-2 text-slate-300 hover:text-slate-200">contact&#64;example.com</a>
                    </li>
                    <li class="inline-flex items-center ms-2">
                        <ul class="list-none space-x-3">
                            <li class="inline-flex mb-0"><a [routerLink]="[]" class="text-slate-300 hover:text-red-500"><i data-feather="facebook" class="size-4 align-middle" title="facebook"></i></a></li>
                            <li class="inline-flex ms-2 mb-0"><a [routerLink]="[]" class="text-slate-300 hover:text-red-500"><i data-feather="instagram" class="size-4 align-middle" title="instagram"></i></a></li>
                            <li class="inline-flex ms-2 mb-0"><a [routerLink]="[]" class="text-slate-300 hover:text-red-500"><i data-feather="twitter" class="size-4 align-middle" title="twitter"></i></a></li>
                            <li class="inline-flex ms-2 mb-0"><a routerLink="tel:+152534-468-854" class="text-slate-300 hover:text-red-500"><i data-feather="phone" class="size-4 align-middle" title="phone"></i></a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
